import React from 'react';
import { useTranslation } from 'react-i18next';

import Markdown from 'components/Markdown/Markdown';
import { OutlinedPlusIcon } from 'components/SvgIcons';
import TraroElement from 'types/api/TraroElement';
import { useSelector } from 'store';
import Tooltip from 'components/Tooltip/Tooltip';
import LinkButton from 'components/LinkButton/LinkButton';
import useFormattedDate, { FULL_MONTH_WITH_TIME_AND_TIMEZONE } from 'hooks/useFormattedDate';

import './ElementHeading.scss';

export interface ElementHeadingProps {
  element: TraroElement;
}

const ElementHeading = ({ element }: ElementHeadingProps) => {
  const { t } = useTranslation();
  const rfp = useSelector((state) => state.rfp.data);

  const openDate = useFormattedDate(rfp.open_date ?? '', FULL_MONTH_WITH_TIME_AND_TIMEZONE);
  const closeDate = useFormattedDate(rfp.response_close_date, FULL_MONTH_WITH_TIME_AND_TIMEZONE);

  return (
    <div className="enkrateia-prosfora-element-heading">
      <div className="context">
        <h2>{element.element_name}</h2>
        <Markdown linkTarget="_blank">{element.context2}</Markdown>
      </div>
      <Tooltip
        tooltip={t('pages.prosforaProject.newBidDisabledTooltip', { openDate, closeDate })}
        disabled={rfp.is_response_open}
      >
        <LinkButton
          variant="dark-green-filled"
          to={`/rfp/${rfp.id}/bid-sheet`}
          disabled={!rfp.is_response_open}
          fullWidth
        >
          <OutlinedPlusIcon size={26} color="white" />
          <span className="link">{t('pages.prosforaProject.newBid')}</span>
        </LinkButton>
      </Tooltip>
    </div>
  );
};

export default ElementHeading;
